import { create } from "zustand";

// one short app-wide notice with an optional action ("복사했어요 · 내용 보기")
export interface ToastAction { label: string; run: () => void }

interface ToastState {
  msg: string | null;
  action: ToastAction | null;
  seq: number;   // bumps on every show so the same message restarts its timer
  show: (msg: string, action?: ToastAction) => void;
  hide: () => void;
}

export const useToast = create<ToastState>((set, get) => ({
  msg: null,
  action: null,
  seq: 0,
  show: (msg, action) => set({ msg, action: action ?? null, seq: get().seq + 1 }),
  hide: () => set({ msg: null, action: null }),
}));
